import React from 'react';
import {IProduct} from '@wix/wixstores-graphql-schema/dist/es/src/graphql-schema';
import s from './Ribbon.scss';
import {DataHook} from '../ProductItem';

export interface IRibbonProps {
  product: IProduct;
}

export class Ribbon extends React.Component<IRibbonProps> {
  public render() {
    const {
      product: {ribbon},
    } = this.props;
    return (
      ribbon && (
        <span className={s.ribbon} data-hook={DataHook.RibbonNew}>
          {ribbon}
        </span>
      )
    );
  }
}
